module.exports = __webpack_public_path__ + "img/pageBgc.4b94898a.png";